"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconYoutube = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IconYoutube = (_a) => {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId }, props, { children: [title ? (0, jsx_runtime_1.jsx)("title", { id: titleId, children: title }) : null, (0, jsx_runtime_1.jsx)("path", { fill: "#464650", fillRule: "evenodd", d: "m15.075 12.39-4.251 2.15c-.422.21-.77.019-.77-.431v-4.22c0-.45.348-.64.77-.43l4.25 2.15c.422.221.422.562 0 .78m5.62-4.36c-.22-.9-1.013-1.548-1.952-1.65-2.235-.24-4.49-.38-6.738-.38a64 64 0 0 0-6.747.38c-.939.102-1.72.75-1.94 1.65C3 9.3 3 10.69 3 12s0 2.702.316 3.973c.212.898 1.002 1.548 1.941 1.648 2.235.24 4.49.38 6.737.38 2.259 0 4.515-.141 6.748-.38.94-.1 1.722-.75 1.941-1.648C21 14.702 21 13.309 21 12s0-2.7-.306-3.97" })] })));
};
exports.IconYoutube = IconYoutube;
exports.IconYoutube.defaultProps = {
    height: '30px',
    width: '30px',
};
exports.default = exports.IconYoutube;
